import { render, staticRenderFns } from "./DeleteUnreleasedPolicy.vue?vue&type=template&id=63720b68&"
import script from "./DeleteUnreleasedPolicy.vue?vue&type=script&lang=js&"
export * from "./DeleteUnreleasedPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports